import {
  LOAD_MULTI_ACCOUNTS,
  MULTI_ACCOUNTS_LOADED,
  RESET_ERROR,
  SYNC_FAILED,
} from './actionTypes';
import type { IMultiAccountsState } from './types';

export const initialState = {
  error: null,
  loaded: false,
  loading: false,
  multiAccounts: [],
  selectedCustomerReference: '',
  loadedProductType: '',
};

export const reducer = (state: IMultiAccountsState, action: { type: any; payload?: any }) => {
  switch (action.type) {
    case LOAD_MULTI_ACCOUNTS:
      return {
        ...state,
        error: null,
        loading: true,
        multiAccounts: [],
      };
    case MULTI_ACCOUNTS_LOADED:
      return {
        ...state,
        error: null,
        multiAccounts: action.payload.multiAccounts,
        loading: false,
        loaded: true,
        selectedCustomerReference: action.payload.customerReference,
        loadedProductType: action.payload.productType,
      };
    case SYNC_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        multiAccounts: [],
        selectedCustomerReference: action.payload.customerReference,
        loadedProductType: action.payload.productType,
      };
    case RESET_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
